
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, from, map, of, switchMap } from 'rxjs';
import { ICommunityGrant, LGEDataService } from 'src/commons';
import { LoadCommunityGrantState, LoadCommunityGrantStateSuccess, LoadCommunityGrantStateFail, CommunityGrantActionTypes } from './community-grant.actions';

@Injectable()
export class CommunityGrantEffects {

    loadCommunityGrantState$ = createEffect(
        () => this.actions$.pipe(
            ofType(CommunityGrantActionTypes.LoadCommunityGrantState),
            map((action: LoadCommunityGrantState) => action.formId),
            switchMap(
                (formId) => from(this.lgeService.formCGById(formId)).pipe(
                    map((state: ICommunityGrant) => new LoadCommunityGrantStateSuccess(state)),
                    catchError(error => of(new LoadCommunityGrantStateFail(error)))
                )
            )
        )
    );


    constructor(
        private actions$: Actions,
        private lgeService: LGEDataService
    ) { }
}